import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledDivider = styled.div`
  margin: 20px 0;
  height: 1px;
  width: 100%;
  background-color: ${colors.primary25};
`;

export const StyledSectionTypography = styled(Typography)`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  color: ${colors.primary500};
`;
